import Vue from 'vue'
import Base from '@/layouts/base'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'


// --------------
// VueMask setup
// --------------

import VueMask from 'v-mask'
Vue.use(VueMask)

Vue.config.productionTip = false

var oldLog = console.log;
console.log = function( ...items ) {
  // Call native method first  
  oldLog.apply(this, items)
  store.commit('console/APPEND', items)
}

import './registerServiceWorker'

new Vue({
  router,
  store,
  vuetify,
  render: h => h(Base)
}).$mount('#app')
